import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { apiGet } from "../../api";
import { useTicketContext } from "./useTicket";

/** Opens a stored attachment (email file or text picture) through a short-lived link. */
export function useAttachmentOpener() {
  const { config } = useTicketContext();
  const auth = useAuth();
  const [failed, setFailed] = useState("");
  const open = (id: string) => {
    const tab = window.open("", "_blank"); // opened now: a tab opened after waiting is often blocked
    setFailed("");
    apiGet<{ url: string }>(config, auth.user?.access_token ?? "", `/attachments/${id}`)
      .then((r) => { if (tab) tab.location.href = r.url; else window.location.href = r.url; })
      .catch((e: Error) => { tab?.close(); setFailed(e.message); });
  };
  return { open, failed };
}
